import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  templateUrl: './progress-bar.html',
  host: {
    class: 'block',
  },
})
export class ProgressBarComponent {
  private progressValue = 0;

  @Input()
  set progress(value: number | string | null | undefined) {
    const numericValue = Number(value ?? 0);

    this.progressValue = Number.isFinite(numericValue)
      ? Math.min(Math.max(numericValue, 0), 100)
      : 0;
  }

  get progress(): number {
    return this.progressValue;
  }
}
